import {Controller} from "stimulus"

/**
 * FWA dashboard — confirm before navigating to retake the assessment.
 * Controller element is the dashboard root; overlay/card are targets.
 */
export default class extends Controller {
  static get targets() {
    return ["overlay", "card", "closeButton"]
  }

  connect() {
    this._boundHandleKeydown = this._handleKeydown.bind(this)
    this._triggerElement = null
  }

  disconnect() {
    document.removeEventListener("keydown", this._boundHandleKeydown)
    document.body.style.overflow = ""
  }

  open(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this._triggerElement = (event && event.currentTarget) || document.activeElement

    if (!this.hasOverlayTarget) return

    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("fwa-retake-modal-visible")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this._boundHandleKeydown)

    requestAnimationFrame(() => {
      if (this.hasCloseButtonTarget) {
        this.closeButtonTarget.focus()
      } else {
        this._trapFocus()
      }
    })
  }

  close() {
    if (!this._isOpen()) return

    this.overlayTarget.classList.remove("fwa-retake-modal-visible")
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this._boundHandleKeydown)

    if (this._triggerElement && this._triggerElement.focus) {
      this._triggerElement.focus()
    }
    this._triggerElement = null
  }

  confirmRetake() {
    const url = this.element.getAttribute("data-fwa-retake-modal-retake-url")
    if (!url) {
      console.warn("fwa-retake-modal: missing retake URL")
      return
    }
    this.close()
    window.location.assign(url)
  }

  backdropClick(event) {
    if (this.hasCardTarget && !this.cardTarget.contains(event.target)) {
      this.close()
    }
  }

  _isOpen() {
    return this.hasOverlayTarget && !this.overlayTarget.classList.contains("hidden")
  }

  _handleKeydown(event) {
    if (!this._isOpen()) return
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
      return
    }
    if (event.key === "Tab") {
      this._handleTabTrap(event)
    }
  }

  _trapFocus() {
    const focusable = this._getFocusableElements()
    if (focusable.length > 0) {
      focusable[0].focus()
    }
  }

  _getFocusableElements() {
    if (!this.hasCardTarget) return []
    return Array.from(
      this.cardTarget.querySelectorAll(
        'button:not([disabled]):not([hidden]), [href]:not([hidden]), input:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'
      )
    ).filter((el) => el.offsetParent !== null)
  }

  _handleTabTrap(event) {
    const focusable = this._getFocusableElements()
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault()
        last.focus()
      }
    } else if (document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
